import React from "react"
import { connect } from "react-redux"
import get from "lodash/get"
import { graphql } from "gatsby"
import { INLINES } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import {
  setInitialPageLoad,
  setShowAnnoucementBar,
  setAnnouncementBarData,
} from "../state/global"

import Layout from "../components/global/layout"
import SEO from "../components/global/seo"
import Footer from "../components/global/footer"
import Accordion from "../components/global/accordion"
import ContactBar from "../components/global/contactBar"
import NavBar from "../components/global/navBar"
import LogoBox from "../components/global/logoBox"

import LearnMore from "../components/homepage/learn"
import HiddenClocks from "../components/global/hiddenClocks"
import OurTeam from "../components/homepage/ourTeam"
import WhatWeDo from "../components/homepage/whatWeDo"
import SoftFooter from "../components/global/softFooter"
import Community from "../components/homepage/community"
import TalentSpotlight from "../components/homepage/talentSpotlight"
import SiteCredit from "../components/global/siteCredit"

import CaseStudyFeatured from "../components/homepage/caseStudyFeatured"
import CaseStudyArchive from "../components/homepage/caseStudyArchive"

import poster from "../images/poster.png"
import sizzle from "../images/video/sizzle_desktop.mp4"

class IndexPage extends React.Component {
  render() {
    let featured = get(this, "props.data.allContentfulWorkFeatured.edges")
    let ourTeam = get(this, "props.data.allContentfulOurTeam.edges")
    let announcement = get(
      this,
      "props.data.allContentfulAnnouncementBar.edges"
    )
    let talent = get(this, "props.data.allContentfulTalentSpotlight.edges")
    let workArchive = get(this, "props.data.allContentfulWorkArchive.edges")
    featured = featured.map(i => i.node)
    featured.sort((a, b) => {
      return a.order - b.order
    })
    ourTeam = ourTeam.map(i => i.node);
    talent = talent.map(i => i.node)
    workArchive = workArchive.map(i => i.node)
    announcement = announcement.map(i => i.node)[0]
    let json = announcement.childContentfulAnnouncementBarBodyRichTextNode.json
    const options = {
      renderNode: {
        [INLINES.ENTRY_HYPERLINK]: node => {
          const link = node.data.target.fields.slug["en-US"]
          const title = node.data.target.fields.title["en-US"]
          return (
            <a target="_blank" rel="noopener noreferrer" href={link}>
              {title}
            </a>
          )
        },
      },
    }
    if (announcement && this.props.initialPageLoad) {
      this.props.dispatch(setShowAnnoucementBar(false))
      this.props.dispatch(setInitialPageLoad(false))
      this.props.dispatch(
        setAnnouncementBarData({
          type: "announcement",
          title: announcement.title,
          info: documentToReactComponents(json, options),
        })
      )
    }

    return (
      <Layout>
        <SEO title="Home" />
        <div
          className={`body-container ${this.props.dragging ? "minimize" : ""}`}
        >
          <NavBar />
          <HiddenClocks />
          <LogoBox />
          <LearnMore />

          <Accordion 
            id={1}
            title={"Case Studies"} 
            slug={"case_studies"}
            nested
          >
            <CaseStudyFeatured featured={featured} />
          </Accordion>
          <Accordion 
            id={2} 
            title={"Clients"}
            slug={"our-clients"}
            nested
          >
            <div className="video-container-outer-index">
              <div className="video-container">
                <video
                  controls
                  autoPlay={!this.props.mobile}
                  muted
                  loop
                  poster={poster}
                >
                  <source src={sizzle} type="video/mp4" />
                </video>
              </div>
            </div>
            <CaseStudyArchive archived={workArchive} />
          </Accordion>
          <Accordion 
           id={3} 
           title={"What We Do"}
           slug={"what-we-do"}
           nested
          >
            <WhatWeDo />
          </Accordion>
          <Accordion 
           id={4} 
           title={"Our Team"}
           slug={"our-team"}
          >
            <OurTeam team={ourTeam} />
          </Accordion>
          <Accordion 
           id={5} 
           title={"Community"} 
           slug={"community"}
           nested
          >
            <Community />
          </Accordion>
          <Accordion 
           id={6}
           title={"Spotlight"}
           slug={"spotlight"}
           nested
          >
            <TalentSpotlight spotlight={talent} />
          </Accordion>
          <Accordion 
           id={7} 
           title={"RAD Shop"}
           isNew 
           link 
           to={"/shop"} 
          />
          <Accordion 
             id={8} 
             title={"Get In Touch"}
             slug={"get-in-touch"}
             nested 
             lastChild
          >
            <ContactBar />
          </Accordion>
          <SoftFooter />
          <Footer />
          <SiteCredit />
        </div>
      </Layout>
    )
  }
}


export default connect(
  state => ({
    containerSize: state.global.containerSize,
    mobile: state.global.mobile,
    dragging: state.navbar.dragging,
    initialPageLoad: state.global.initialPageLoad,
  }),
  null
)(IndexPage)

export const caseStudyFeaturedQuery = graphql`
  query caseStudyFeaturedQuery {
    allContentfulWorkFeatured {
      edges {
        node {
          clientName
          order
          description {
            description
          }
          branding
          designDevelopment
          collaborationCuration
          storytelling
          retailStrategy
          editorial
          logo {
            fluid(maxWidth: 250) {
              src
              ...GatsbyContentfulFluid_noBase64
            }
          }
          logoHover {
            fluid(maxWidth: 250) {
              src
              ...GatsbyContentfulFluid_noBase64
            }
          }
          caseStudyImages {
            title
            description
            file {
              url
              contentType
            }
            fluid(maxWidth: 1440) {
              src
              ...GatsbyContentfulFluid_noBase64
            }
          }
        }
      }
    }
    allContentfulWorkArchive(sort: { fields: createdAt, order: ASC }) {
      edges {
        node {
          clientName
          logo {
            file {
              url
              contentType
            }
            fluid(maxWidth: 100) {
              src
              ...GatsbyContentfulFluid_noBase64
            }
          }
        }
      }
    }
    allContentfulOurTeam(sort: { fields: order }) {
      edges {
        node {
          name
          title
          image {
            fluid(maxWidth: 450) {
              src
              ...GatsbyContentfulFluid_noBase64
            }
          }
          imageHover {
            fluid(maxWidth: 450) {
              src
              ...GatsbyContentfulFluid_noBase64
            }
          }
          order
        }
      }
    }
    allContentfulAnnouncementBar {
      edges {
        node {
          title
          childContentfulAnnouncementBarBodyRichTextNode {
            json
          }
        }
      }
    }
    allContentfulTalentSpotlight {
      edges {
        node {
          displayName
          instagramLink
          coverImage {
            file {
              url
            }
            fluid(maxWidth: 720) {
              src
              ...GatsbyContentfulFluid_noBase64
            }
          }
        }
      }
    }
  }
`
